import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = ['Lista rápida para reiniciar tu casa en 30 minutos', 'Frases de motivación para mujeres que se sienten abrumadas', 'Checklist semanal de organización', 'Plan mensual para mantener el orden', 'Página de compromiso personal', 'Worksheets imprimibles', 'Preguntas de reflexión', 'Ejercicios diarios', 'Checklists prácticas'];
export function Bonuses() {
  return <section className="w-full bg-linen px-5 py-20 sm:px-8 sm:py-28" data-id="element-12" data-mp="5vqkkcsh260o">
      <div className="mx-auto max-w-5xl" data-id="element-13" data-mp="5tvxartqa1tf">
        <header className="flex items-center gap-4" data-id="element-14" data-mp="3o24um0nmdvts">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-terracotta text-cream" data-id="element-15" data-mp="3o3ps9z58duvv">
            <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-16" data-mp="3t2j6jtscdpx3" />
          </span>
          <div data-id="element-17" data-mp="1mb1jzbdqch98">
            <p className="text-[0.7rem] uppercase tracking-[0.22em] text-clay" data-id="element-18" data-mp="1m8fdzg6hm9t4">
              Incluido sin costo extra
            </p>
            <h2 className="font-serif text-4xl leading-tight text-ink sm:text-5xl" data-id="element-19" data-mp="3idwmvfdl54j4">
              Bonos especiales
            </h2>
          </div>
        </header>

        <ul className="mt-12 grid gap-px overflow-hidden border border-sand bg-sand sm:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="3ddirawt67n1z">
          {bonuses.map((bonus, index) => <motion.li key={bonus} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="flex items-start gap-3 bg-linen p-6 transition-colors duration-200 hover:bg-cream" data-id="element-21" data-mp="3n6g0udg6q1og" data-mpi={index}>
              <span className="mt-1 font-serif text-lg text-clay" aria-hidden="true" data-id="element-22" data-mp="33hfe8vws6409">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="text-base leading-relaxed text-cocoa" data-id="element-23" data-mp="no6rfo6edgpx">{bonus}</span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}